<template>
  <div class="security">
    <h1 class="security__title page-title">
      Change Password
    </h1>

    <div class="security__card card">
      <div class="security__form">
        <el-form
          :model="securityFormData"
          :rules="rules"
          ref="securityForm"
          class="security__form"
          label-position="top"
        >
          <el-form-item
            :error="errors.currentPassword"
            prop="currentPassword"
            label="Your current password"
          >
            <el-input
              v-model="securityFormData.currentPassword"
              show-password
            ></el-input>
          </el-form-item>

          <el-form-item
            :error="errors.password"
            prop="password"
            label="Password"
          >
            <el-input v-model="securityFormData.password" show-password />
          </el-form-item>

          <el-form-item
            :error="errors.confirmPassword"
            prop="confirmPassword"
            label="Re-enter password"
          >
            <el-input
              v-model="securityFormData.confirmPassword"
              show-password
            />
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="security__buttons">
      <el-button
        type="primary"
        @click="validateForm"
        :disabled="isButtonDisabled('resetPassword')"
      >
        Change password
      </el-button>
    </div>
  </div>
</template>

<script>
import { disableButton } from '@/mixins/disableButton.js';
import { showMessage } from '@/utils/messages.js';
import { parseErrorsByFields } from '@/utils/index.js';
import { changePassword } from '@/api/user.js';

export default {
  name: 'Security',
  mixins: [disableButton],
  props: {
    userContactInfo: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      securityFormData: {
        password: '',
        confirmPassword: '',
        currentPassword: '',
      },
      errors: {
        password: '',
        confirmPassword: '',
        currentPassword: '',
      },
      rules: {
        password: [
          {
            required: true,
            message: 'Please enter new password',
            trigger: 'blur',
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: 'Please repeat new password',
            trigger: 'blur',
          },
        ],
        currentPassword: [
          {
            required: true,
            message: 'Please enter your current password',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    isFormFilled() {
      const { securityFormData } = this;
      return Object.values(securityFormData).every((value) => !!value);
    },
  },
  methods: {
    showMessage,
    parseErrorsByFields,
    async requestResetPassword() {
      this.disableButton('resetPassword');
      const {
        password,
        confirmPassword,
        currentPassword,
      } = this.securityFormData;
      const { success, errors } = await changePassword({
        password,
        confirmPassword,
        currentPassword,
      });
      this.enableButton('resetPassword');

      if (errors) {
        this.errors = { ...this.errors, ...this.parseErrorsByFields(errors) };
      } else if (success) {
        this.showMessage({
          type: 'success',
          message: 'Your password has been changed successfully.',
        });
        this.clearForm();
        this.clearErrors();
      }
    },
    validateForm() {
      const { isFormFilled } = this;

      this.$refs.securityForm.validate();
      if (isFormFilled) {
        this.requestResetPassword();
      }
    },
    clearForm() {
      const { securityFormData } = this;
      for (const fieldName in securityFormData) {
        securityFormData[fieldName] = '';
      }
    },
    clearErrors() {
      const { errors } = this;
      for (const fieldName in errors) {
        errors[fieldName] = '';
      }
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/shared/_globals.scss';

.security {
  &__title {
    margin: 0;
    margin: var(--global-dimension-size-250) 0 var(--global-dimension-size-200);

    font-weight: normal;
    font-size: var(--font-size-800);
    line-height: 1.6;
  }

  &__card {
    margin-bottom: 30px;
  }

  &__subtitle {
    margin-bottom: var(--global-dimension-size-200);

    font-size: var(--font-size-200);
    line-height: 1.6;
  }

  &__buttons {
    text-align: right;
  }
}
</style>
